import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GraphProfileService {
  constructor(private readonly http: HttpClient) {}

  async fetchProfilePhoto(userEmail?: string): Promise<string | null> {
    const accessToken = sessionStorage.getItem('token');

    if (!accessToken) {
      return null;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`
    });

    const endpoints = userEmail
      ? [
          `${environment.graphApiUrl}/users/${encodeURIComponent(userEmail)}/photo/$value`,
          `${environment.graphApiUrl}/me/photo/$value`
        ]
      : [`${environment.graphApiUrl}/me/photo/$value`];

    for (const url of endpoints) {
      try {
        const photoBlob = await firstValueFrom(
          this.http.get(url, {
            headers,
            responseType: 'blob'
          })
        );

        if (photoBlob && photoBlob.size > 0) {
          return URL.createObjectURL(photoBlob);
        }
      } catch (_error) {
        console.trace('Error fetching profile photo:', _error);
        // Continue to fallback endpoint if available.
      }
    }

    return null;
  }
}